module.exports = __webpack_public_path__ + "img/test-drive.7e7c61e3.jpg";